import { FormControl, Theme } from "@mui/material";
import { createStyles, WithStyles, withStyles } from "@mui/styles";
import { observer } from "mobx-react";
import * as React from "react";
import Typography from "./Typography";
import Tooltip from "../coreui/Tooltip";
import useIsOverflowing from "../core/useIsOverflowing";

interface Props {
  children?: React.ReactNode;
  label: string;
}

const styles = (theme: Theme) =>
  createStyles({
    label: {
      color: theme.palette.grey[700],
      marginBottom: 8,
    },
    root: {
      "&:hover": { backgroundColor: "transparent" },
      backgroundColor: "transparent",
    },
  });

const Label: React.FC<
  Props & { isFocused: boolean } & WithStyles<typeof styles>
> = (props) => {
  const { isOverflowing, ref } = useIsOverflowing();

  return (
    <Tooltip
      disableFocusListener
      forceShow={props.isFocused}
      isOverflowing={isOverflowing}
      placement="top"
      title={props.label}
    >
      <Typography
        className={props.classes.label}
        ellipsis
        ref={ref}
        variant="caption"
      >
        {props.label}
      </Typography>
    </Tooltip>
  );
};

const FormData: React.FC<Props & WithStyles<typeof styles>> = (props) => {
  const [isFocused, setIsFocused] = React.useState(false);

  return (
    <FormControl className={props.classes.root} fullWidth>
      <Label isFocused={isFocused} {...props} />
      <Typography
        component="div"
        onBlur={() => setIsFocused(false)}
        onFocus={() => setIsFocused(true)}
        style={{ minHeight: 20 }}
      >
        {props.children}
      </Typography>
    </FormControl>
  );
};

export default withStyles(styles)(observer(FormData));
